import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { RawHtml } from '../../index'

export default function ProductBadges({ badge, className }) {
  const cls = classNames('product-badge-wrapper', className)

  return (
    <RawHtml
      element="div"
      className={cls}
      html={badge}
      forceStrictMode={true}
    />
  )
}

ProductBadges.propTypes = {
  badge: PropTypes.string,
  className: PropTypes.string,
}

export { default as productBadgesVariants } from './variants.js'
